var render, staticRenderFns
import script from "./ordergf.vue?vue&type=script&lang=js"
export * from "./ordergf.vue?vue&type=script&lang=js"
import style0 from "./ordergf.vue?vue&type=style&index=0&id=12672b42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12672b42",
  null
  
)

export default component.exports